// This file was generated from the SVG file exported from SVGator. Do not change manually!
// Use the script in the scripts folder to generate this file
import { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

interface Props extends ComponentPropsWithoutRef<'svg'> {
  selected?: number;
}

const FeedSourcesMobileBg6 = ({ selected, ...props }: Props) => {
  const selectedStyles = {
    bulletColor: 'var(--sb-selected-bullet-color)',
    bulletGlowColor: 'var(--sb-selected-bullet-glow-color)',
    tailColor: 'var(--sb-selected-tail-color)',
  };

  const styles = {
    bulletColor: 'var(--sb-bullet-color)',
    bulletGlowColor: 'var(--sb-bullet-glow-color)',
    tailColor: 'var(--sb-tail-color)',
    stopColor: 'var(--sb-line-color)', // Replace all <stop id="...-stroke-1" stopColor="#initial-color" /> with this value
  };

  return (
    <AnimatedSvg
      id="e036KGUVLJO1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 320 250"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      width="320"
      height="250"
      className="source-background"
      {...props}
    >
      <defs>
        <linearGradient
          id="e036KGUVLJO7-stroke"
          x1="0.370708"
          y1="0.690679"
          x2="0.381501"
          y2="0.997708"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO7-stroke-0"
            offset="0%"
            stopColor={selected === 5 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO7-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO8-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO8-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO8-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO8-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO8-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO8-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO8-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO8-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO9-stroke"
          x1="-5275.007951"
          y1="0.083835"
          x2="-5275.007951"
          y2="0.902057"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO9-stroke-0"
            offset="0%"
            stopColor={selected === 5 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO9-stroke-1" offset="100%" stopColor="rgba(64,73,168,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO10-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO10-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO10-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO10-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO10-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO10-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO10-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO10-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO10-filter-blur-0" stdDeviation="3,3" result="result" />
        </filter>
        <filter id="e036KGUVLJO11-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO11-filter-blur-0" stdDeviation="0,0" result="result" />
        </filter>
        <filter id="e036KGUVLJO12-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO12-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO12-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO12-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO12-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO12-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO12-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO12-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO13-stroke"
          x1="-5275.007951"
          y1="0.083835"
          x2="-5275.007951"
          y2="0.902057"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO13-stroke-0"
            offset="0%"
            stopColor={selected === 5 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO13-stroke-1" offset="100%" stopColor="rgba(64,73,168,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO14-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO14-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO14-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO14-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO14-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO14-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO14-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO14-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO14-filter-blur-0" stdDeviation="3,3" result="result" />
        </filter>
        <filter id="e036KGUVLJO15-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO15-filter-blur-0" stdDeviation="0,0" result="result" />
        </filter>
        <linearGradient
          id="e036KGUVLJO17-stroke"
          x1="0.311309"
          y1="0.695205"
          x2="0.32485"
          y2="0.997707"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO17-stroke-0"
            offset="0%"
            stopColor={selected === 4 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO17-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO18-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO18-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO18-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO18-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO18-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO18-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO18-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO18-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO19-stroke"
          x1="18.033484"
          y1="0.902563"
          x2="18.033484"
          y2="0.00616"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e036KGUVLJO19-stroke-0" offset="0%" stopColor="rgba(126,166,255,0)" />
          <stop
            id="e036KGUVLJO19-stroke-1"
            offset="100%"
            stopColor={selected === 4 ? selectedStyles.tailColor : styles.tailColor}
          />
        </linearGradient>
        <filter id="e036KGUVLJO20-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO20-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO20-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO20-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO20-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO20-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO20-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO20-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO20-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <filter id="e036KGUVLJO22-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO22-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO22-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO22-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO22-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO22-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO22-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO22-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO23-stroke"
          x1="18.033484"
          y1="0.902563"
          x2="18.033484"
          y2="0.00616"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e036KGUVLJO23-stroke-0" offset="0%" stopColor="rgba(126,166,255,0)" />
          <stop
            id="e036KGUVLJO23-stroke-1"
            offset="100%"
            stopColor={selected === 4 ? selectedStyles.tailColor : styles.tailColor}
          />
        </linearGradient>
        <filter id="e036KGUVLJO24-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO24-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO24-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO24-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO24-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO24-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO24-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO24-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO24-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <filter id="e036KGUVLJO26-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO26-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO26-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO26-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO26-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO26-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO26-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO26-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO27-stroke"
          x1="18.033484"
          y1="0.902563"
          x2="18.033484"
          y2="0.00616"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e036KGUVLJO27-stroke-0" offset="0%" stopColor="rgba(126,166,255,0)" />
          <stop
            id="e036KGUVLJO27-stroke-1"
            offset="100%"
            stopColor={selected === 4 ? selectedStyles.tailColor : styles.tailColor}
          />
        </linearGradient>
        <filter id="e036KGUVLJO28-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO28-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO28-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO28-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO28-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO28-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO28-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO28-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO28-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <linearGradient
          id="e036KGUVLJO31-stroke"
          x1="0.5"
          y1="0.695258"
          x2="0.5"
          y2="0.997712"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO31-stroke-0"
            offset="0%"
            stopColor={selected === 3 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO31-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO32-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO32-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO32-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO32-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO32-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO32-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO32-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO32-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO33-stroke"
          x1="18.752869"
          y1="0.111776"
          x2="18.752869"
          y2="0.915856"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO33-stroke-0"
            offset="0%"
            stopColor={selected === 3 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO33-stroke-1" offset="100%" stopColor="rgba(126,166,255,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO34-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO34-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO34-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO34-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO34-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO34-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO34-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO34-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO34-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <filter id="e036KGUVLJO36-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO36-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO36-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO36-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO36-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO36-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO36-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO36-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO37-stroke"
          x1="18.752869"
          y1="0.111776"
          x2="18.752869"
          y2="0.915856"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO37-stroke-0"
            offset="0%"
            stopColor={selected === 3 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO37-stroke-1" offset="100%" stopColor="rgba(126,166,255,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO38-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO38-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO38-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO38-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO38-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO38-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO38-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO38-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO38-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <linearGradient
          id="e036KGUVLJO41-stroke"
          x1="0.5"
          y1="0.695267"
          x2="0.5"
          y2="0.997712"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO41-stroke-0"
            offset="0%"
            stopColor={selected === 2 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO41-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO42-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO42-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO42-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO42-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO42-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO42-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO42-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO42-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO43-stroke"
          x1="3912.496966"
          y1="0.052899"
          x2="3912.496966"
          y2="0.846185"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO43-stroke-0"
            offset="0%"
            stopColor={selected === 2 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO43-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO44-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO44-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO44-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO44-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO44-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO44-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO44-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO44-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO44-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <filter id="e036KGUVLJO46-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO46-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO46-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO46-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO46-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO46-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO46-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO46-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO47-stroke"
          x1="3912.496966"
          y1="0.052899"
          x2="3912.496966"
          y2="0.846185"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO47-stroke-0"
            offset="0%"
            stopColor={selected === 2 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO47-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO48-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO48-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO48-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO48-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO48-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO48-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO48-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO48-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO48-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <linearGradient
          id="e036KGUVLJO51-stroke"
          x1="0.5"
          y1="0.690629"
          x2="0.5"
          y2="0.997707"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO51-stroke-0"
            offset="0%"
            stopColor={selected === 1 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO51-stroke-1" offset="100%" stopColor="rgba(96,105,202,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO52-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO52-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO52-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO52-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO52-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO52-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO52-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO52-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO53-stroke"
          x1="5940.262673"
          y1="1.161515"
          x2="5940.262673"
          y2="0.096616"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e036KGUVLJO53-stroke-0" offset="0%" stopColor="rgba(96,105,202,0)" />
          <stop
            id="e036KGUVLJO53-stroke-1"
            offset="100%"
            stopColor={selected === 1 ? selectedStyles.tailColor : styles.tailColor}
          />
        </linearGradient>
        <filter id="e036KGUVLJO54-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO54-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO54-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO54-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO54-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO54-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO54-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO54-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO54-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <filter id="e036KGUVLJO56-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO56-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO56-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO56-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO56-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO56-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO56-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO56-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO57-stroke"
          x1="5940.262673"
          y1="1.161515"
          x2="5940.262673"
          y2="0.096616"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e036KGUVLJO57-stroke-0" offset="0%" stopColor="rgba(96,105,202,0)" />
          <stop
            id="e036KGUVLJO57-stroke-1"
            offset="100%"
            stopColor={selected === 1 ? selectedStyles.tailColor : styles.tailColor}
          />
        </linearGradient>
        <filter id="e036KGUVLJO58-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO58-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO58-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO58-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO58-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO58-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO58-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO58-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO58-filter-blur-0" stdDeviation="2,2" result="result" />
        </filter>
        <linearGradient
          id="e036KGUVLJO61-stroke"
          x1="-0.002599"
          y1="1"
          x2="0.218911"
          y2="0.828707"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop id="e036KGUVLJO61-stroke-0" offset="0%" stopColor="rgba(96,105,202,0)" />
          <stop
            id="e036KGUVLJO61-stroke-1"
            offset="100%"
            stopColor={selected === 0 ? selectedStyles.tailColor : styles.tailColor}
          />
        </linearGradient>
        <filter id="e036KGUVLJO62-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO62-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO62-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO62-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO62-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO62-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO62-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO62-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO63-stroke"
          x1="12.982437"
          y1="0.057871"
          x2="12.982437"
          y2="0.848333"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO63-stroke-0"
            offset="0%"
            stopColor={selected === 0 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO63-stroke-1" offset="100%" stopColor="rgba(126,166,255,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO64-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO64-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO64-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO64-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO64-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO64-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO64-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO64-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO64-filter-blur-0" stdDeviation="3,3" result="result" />
        </filter>
        <filter id="e036KGUVLJO65-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO65-filter-blur-0" stdDeviation="0,0" result="result" />
        </filter>
        <filter id="e036KGUVLJO66-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO66-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="3,3" />
          <feOffset id="e036KGUVLJO66-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO66-filter-drop-shadow-0-flood" floodColor="rgba(217,217,217,0.4)" />
          <feComposite id="e036KGUVLJO66-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO66-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO66-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO66-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient
          id="e036KGUVLJO67-stroke"
          x1="5054.317069"
          y1="0.06831"
          x2="5054.317069"
          y2="0.829921"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="e036KGUVLJO67-stroke-0"
            offset="0%"
            stopColor={selected === 0 ? selectedStyles.tailColor : styles.tailColor}
          />
          <stop id="e036KGUVLJO67-stroke-1" offset="100%" stopColor="rgba(126,166,255,0)" />
        </linearGradient>
        <filter id="e036KGUVLJO68-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO68-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="1,2" />
          <feOffset id="e036KGUVLJO68-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="e036KGUVLJO68-filter-drop-shadow-0-flood" floodColor="#7ea6ff" />
          <feComposite id="e036KGUVLJO68-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="e036KGUVLJO68-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="e036KGUVLJO68-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="e036KGUVLJO68-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="e036KGUVLJO68-filter-blur-0" stdDeviation="3,3" result="result" />
        </filter>
        <filter id="e036KGUVLJO69-filter" x="-150%" width="400%" y="-150%" height="400%">
          <feGaussianBlur id="e036KGUVLJO69-filter-blur-0" stdDeviation="0,0" result="result" />
        </filter>
      </defs>
      <g transform="translate(-22-2.25894)" mask="url(#e036KGUVLJO70)">
        <g transform="translate(.000001 0)">
          <g transform="translate(.088013 1.012683)">
            <g transform="matrix(-1 0 0 1 357.455002 0)">
              <path
                d="M32.0957,218.88v-97.202L86.156086,77.532603v-77.224072"
                fill="none"
                stroke="url(#e036KGUVLJO7-stroke)"
              />
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO8-filter)">
                <path
                  id="e036KGUVLJO9"
                  d="M32.0957,289.88v-43.358702v0v.003136"
                  transform="translate(64.994651-105.187118)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO9-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO10_to" transform="translate(96.798427,143.537316)">
                  <g id="e036KGUVLJO10_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO10"
                      width="10"
                      height="17.142857"
                      rx="0"
                      ry="0"
                      transform="scale(0.7,0.7) translate(-5,-8.571429)"
                      opacity="0"
                      filter="url(#e036KGUVLJO10-filter)"
                      fill={selected === 5 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO11_to" transform="translate(96.798427,142.237316)">
                  <g id="e036KGUVLJO11_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO11"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      filter="url(#e036KGUVLJO11-filter)"
                      fill={selected === 5 ? selectedStyles.bulletColor : styles.bulletColor}
                      strokeMiterlimit="8"
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO12-filter)">
                <path
                  id="e036KGUVLJO13"
                  d="M32.0957,289.88v-43.358702v0v.003136"
                  transform="translate(64.994651-105.187118)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO13-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO14_to" transform="translate(96.798427,143.537316)">
                  <g id="e036KGUVLJO14_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO14"
                      width="10"
                      height="17.142857"
                      rx="0"
                      ry="0"
                      transform="scale(0.7,0.7) translate(-5,-8.571429)"
                      opacity="0"
                      filter="url(#e036KGUVLJO14-filter)"
                      fill={selected === 5 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO15_to" transform="translate(96.798427,142.237316)">
                  <g id="e036KGUVLJO15_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO15"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      filter="url(#e036KGUVLJO15-filter)"
                      fill={selected === 5 ? selectedStyles.bulletColor : styles.bulletColor}
                      strokeMiterlimit="8"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g transform="matrix(-1 0 0 1 367.225189 0)">
              <path
                d="M96.7109,218.88v-97.202l35.869585-44.145397L132.817,0.34375"
                fill="none"
                stroke="url(#e036KGUVLJO17-stroke)"
              />
              <g transform="translate(-64 105.000001)" filter="url(#e036KGUVLJO18-filter)">
                <path
                  id="e036KGUVLJO19"
                  d="M96.711985,210.915719L96.7109,121.678h.001085c0,0,1-1.173693,1-1.173693"
                  transform="translate(64-105.000001)"
                  opacity="0.2"
                  fill="none"
                  stroke="url(#e036KGUVLJO19-stroke)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="e036KGUVLJO20_to" transform="translate(160.8,20.504306)">
                  <g id="e036KGUVLJO20_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO20"
                      width="7"
                      height="12"
                      rx="0"
                      ry="0"
                      transform="translate(-3.5,-6)"
                      opacity="0.7"
                      filter="url(#e036KGUVLJO20-filter)"
                      fill={selected === 4 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO21_to" transform="translate(160.8,20.504307)">
                  <g id="e036KGUVLJO21_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO21"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      fill={selected === 4 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-64 105.000001)" filter="url(#e036KGUVLJO22-filter)">
                <path
                  id="e036KGUVLJO23"
                  d="M96.711985,250.915719L96.7109,216.678h.001085c0,0,1-1.173693,1-1.173693"
                  transform="translate(64-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO23-stroke)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="e036KGUVLJO24_to" transform="translate(160.8,122.504306)">
                  <g id="e036KGUVLJO24_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO24"
                      width="7"
                      height="12"
                      rx="0"
                      ry="0"
                      transform="translate(-3.5,-6)"
                      opacity="0"
                      filter="url(#e036KGUVLJO24-filter)"
                      fill={selected === 4 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO25_to" transform="translate(160.8,122.504307)">
                  <g id="e036KGUVLJO25_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO25"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 4 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-64 105.000001)" filter="url(#e036KGUVLJO26-filter)">
                <path
                  id="e036KGUVLJO27"
                  d="M96.711985,250.915719L96.7109,216.678h.001085c0,0,1-1.173693,1-1.173693"
                  transform="translate(64-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO27-stroke)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="e036KGUVLJO28_to" transform="translate(160.8,122.504306)">
                  <rect
                    id="e036KGUVLJO28"
                    width="7"
                    height="12"
                    rx="0"
                    ry="0"
                    transform="translate(-3.5,-6)"
                    opacity="0"
                    filter="url(#e036KGUVLJO28-filter)"
                    fill={selected === 4 ? selectedStyles.bulletColor : styles.bulletColor}
                  />
                </g>
                <g id="e036KGUVLJO29_to" transform="translate(160.8,122.504307)">
                  <rect
                    id="e036KGUVLJO29"
                    width="10"
                    height="20"
                    rx="0"
                    ry="0"
                    transform="scale(0.5,0.5) translate(-5,-10)"
                    opacity="0"
                    fill={selected === 4 ? selectedStyles.bulletColor : styles.bulletColor}
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(-1 0 0 1 380.03 0)">
              <path
                d="M161.867,218.879v-97.202L180.68,77.67163l.001986-77.363099"
                fill="none"
                stroke="url(#e036KGUVLJO31-stroke)"
              />
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO32-filter)">
                <path
                  id="e036KGUVLJO33"
                  d="M161.867,259.879v-49.389002c0,0-.017-.218699-.017-.218699l.948427-1.875005"
                  transform="translate(64.996501-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO33-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO34_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO34_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO34"
                      width="8.75"
                      height="15"
                      rx="0"
                      ry="0"
                      transform="scale(0.8,0.8) translate(-4.375,-7.5)"
                      opacity="0"
                      filter="url(#e036KGUVLJO34-filter)"
                      fill={selected === 3 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO35_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO35_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO35"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 3 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO36-filter)">
                <path
                  id="e036KGUVLJO37"
                  d="M161.867,259.879v-49.389002c0,0-.017-.218699-.017-.218699l.948427-1.875005"
                  transform="translate(64.996501-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO37-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO38_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO38_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO38"
                      width="8.75"
                      height="15"
                      rx="0"
                      ry="0"
                      transform="scale(0.8,0.8) translate(-4.375,-7.5)"
                      opacity="0"
                      filter="url(#e036KGUVLJO38-filter)"
                      fill={selected === 3 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO39_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO39_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO39"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 3 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
            </g>
            <g transform="translate(-18 0)">
              <path
                d="M161.867,218.879v-97.202L180.68,77.67163l.001986-77.363099"
                fill="none"
                stroke="url(#e036KGUVLJO41-stroke)"
              />
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO42-filter)">
                <path
                  id="e036KGUVLJO43"
                  d="M161.867,259.879v-6.389002c0,0-.017-2.218699-.017-2.218699l-.051573-1.875005"
                  transform="translate(64.996501-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO43-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO44_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO44_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO44"
                      width="8.75"
                      height="15"
                      rx="0"
                      ry="0"
                      transform="scale(0.8,0.8) translate(-4.375,-7.5)"
                      opacity="0"
                      filter="url(#e036KGUVLJO44-filter)"
                      fill={selected === 2 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO45_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO45_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO45"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 2 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO46-filter)">
                <path
                  id="e036KGUVLJO47"
                  d="M161.867,259.879v-6.389002c0,0-.017-2.218699-.017-2.218699l-.051573-1.875005"
                  transform="translate(64.996501-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO47-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO48_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO48_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO48"
                      width="8.75"
                      height="15"
                      rx="0"
                      ry="0"
                      transform="scale(0.8,0.8) translate(-4.375,-7.5)"
                      opacity="0"
                      filter="url(#e036KGUVLJO48-filter)"
                      fill={selected === 2 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO49_to" transform="translate(226.779751,128.661481)">
                  <g id="e036KGUVLJO49_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO49"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 2 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
            </g>
            <g transform="translate(-5.999999 0)">
              <path
                d="M96.7109,218.88v-97.202l35.869585-44.145397L132.817,0.34375"
                fill="none"
                stroke="url(#e036KGUVLJO51-stroke)"
              />
              <g transform="translate(-64 105.000001)" filter="url(#e036KGUVLJO52-filter)">
                <path
                  id="e036KGUVLJO53"
                  d="M96.711985,302.439636L96.7109,234.987317h.001085c0,0,0,0,0,0"
                  transform="translate(64-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO53-stroke)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="e036KGUVLJO54_to" transform="translate(160.8,124.504306)">
                  <g id="e036KGUVLJO54_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO54"
                      width="7"
                      height="12"
                      rx="0"
                      ry="0"
                      transform="translate(-3.5,-6)"
                      opacity="0"
                      filter="url(#e036KGUVLJO54-filter)"
                      fill={selected === 1 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO55_to" transform="translate(160.8,124.504307)">
                  <g id="e036KGUVLJO55_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO55"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 1 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-64 105.000001)" filter="url(#e036KGUVLJO56-filter)">
                <path
                  id="e036KGUVLJO57"
                  d="M96.711985,302.439636L96.7109,234.987317h.001085c0,0,0,0,0,0"
                  transform="translate(64-105.000001)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO57-stroke)"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <g id="e036KGUVLJO58_to" transform="translate(160.8,124.504306)">
                  <g id="e036KGUVLJO58_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO58"
                      width="7"
                      height="12"
                      rx="0"
                      ry="0"
                      transform="translate(-3.5,-6)"
                      opacity="0"
                      filter="url(#e036KGUVLJO58-filter)"
                      fill={selected === 1 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO59_to" transform="translate(160.8,124.504307)">
                  <g id="e036KGUVLJO59_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO59"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      fill={selected === 1 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
              </g>
            </g>
            <g transform="translate(6 0)">
              <path
                d="M32.0957,218.88v-97.202L86.156086,77.532603v-77.224072"
                fill="none"
                stroke="url(#e036KGUVLJO61-stroke)"
              />
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO62-filter)">
                <path
                  id="e036KGUVLJO63"
                  d="M32.0957,321.564875v-89.736339l.005349.041895v.005687"
                  transform="translate(64.994651-105.187118)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO63-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO64_to" transform="translate(96.798427,143.537316)">
                  <g id="e036KGUVLJO64_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO64"
                      width="10"
                      height="17.142857"
                      rx="0"
                      ry="0"
                      transform="scale(0.7,0.7) translate(-5,-8.571429)"
                      opacity="0"
                      filter="url(#e036KGUVLJO64-filter)"
                      fill={selected === 0 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO65_to" transform="translate(96.798427,142.237316)">
                  <g id="e036KGUVLJO65_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO65"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      filter="url(#e036KGUVLJO65-filter)"
                      fill={selected === 0 ? selectedStyles.bulletColor : styles.bulletColor}
                      strokeMiterlimit="8"
                    />
                  </g>
                </g>
              </g>
              <g transform="translate(-65 105.000001)" filter="url(#e036KGUVLJO66-filter)">
                <path
                  id="e036KGUVLJO67"
                  d="M32.0957,321.564875v-89.736339l.005349.041895v.005687"
                  transform="translate(64.994651-105.187118)"
                  opacity="0"
                  fill="none"
                  stroke="url(#e036KGUVLJO67-stroke)"
                  strokeLinecap="round"
                />
                <g id="e036KGUVLJO68_to" transform="translate(96.798427,143.537316)">
                  <g id="e036KGUVLJO68_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO68"
                      width="10"
                      height="17.142857"
                      rx="0"
                      ry="0"
                      transform="scale(0.7,0.7) translate(-5,-8.571429)"
                      opacity="0"
                      filter="url(#e036KGUVLJO68-filter)"
                      fill={selected === 0 ? selectedStyles.bulletColor : styles.bulletColor}
                    />
                  </g>
                </g>
                <g id="e036KGUVLJO69_to" transform="translate(96.798427,142.237316)">
                  <g id="e036KGUVLJO69_tr" transform="rotate(0)">
                    <rect
                      id="e036KGUVLJO69"
                      width="10"
                      height="20"
                      rx="0"
                      ry="0"
                      transform="scale(0.5,0.5) translate(-5,-10)"
                      opacity="0"
                      filter="url(#e036KGUVLJO69-filter)"
                      fill={selected === 0 ? selectedStyles.bulletColor : styles.bulletColor}
                      strokeMiterlimit="8"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <mask id="e036KGUVLJO70" type="luminance" x="-150%" y="-150%" height="400%" width="400%">
          <rect
            width="825.762291"
            height="299.51865"
            rx="0"
            ry="0"
            transform="matrix(1.071737 0 0 0.754544 0 2.098259)"
            fill="#fff"
            strokeWidth="0"
            strokeLinejoin="round"
          />
        </mask>
      </g>
    </AnimatedSvg>
  );
};

const AnimatedSvg = styled.svg`
  #e036KGUVLJO9 {
    animation-name: e036KGUVLJO9__m, e036KGUVLJO9_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO9__m {
    0% {
      d: path('M32.0957,289.88L32.0957,246.521298L32.0957,246.521298L32.0957,246.524434');
    }
    5% {
      d: path('M32.0957,289.88L32.0957,246.521298L32.0957,246.521298L32.0957,246.524434');
    }
    21.25% {
      d: path('M32.0957,219.88L32.0957,121.861988L32.0957,121.861988L33.0957,120.869117');
    }
    35% {
      d: path('M32.0957,129.146811L32.0957,121.678L85.801035,77.955237L85.801035,77.954434');
    }
    50% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
    100% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
  }
  @keyframes e036KGUVLJO9_c_o {
    0% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    22.5% {
      opacity: 1;
    }
    47.5% {
      opacity: 1;
    }
    53.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO10_to {
    animation: e036KGUVLJO10_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO10_to__to {
    0% {
      transform: translate(96.798427px, 143.537316px);
    }
    5% {
      transform: translate(96.798427px, 143.537316px);
    }
    20% {
      transform: translate(97.111986px, 20.771297px);
    }
    21.25% {
      transform: translate(99.798427px, 14.771297px);
    }
    35% {
      transform: translate(148.801035px, -25.679029px);
    }
    36.25% {
      transform: translate(150.920607px, -33.028703px);
    }
    50% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO10_tr {
    animation: e036KGUVLJO10_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO10_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    20% {
      transform: rotate(0deg);
    }
    21.25% {
      transform: rotate(50deg);
    }
    35% {
      transform: rotate(50deg);
    }
    36.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO10 {
    animation: e036KGUVLJO10_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO10_c_o {
    0% {
      opacity: 0;
    }
    7.5% {
      opacity: 0;
    }
    13.75% {
      opacity: 0.7;
    }
    48.75% {
      opacity: 0.7;
    }
    51.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO11_to {
    animation: e036KGUVLJO11_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO11_to__to {
    0% {
      transform: translate(96.798427px, 142.237316px);
    }
    5% {
      transform: translate(96.798427px, 142.237316px);
    }
    20% {
      transform: translate(97.111986px, 20.643116px);
    }
    21.25% {
      transform: translate(99.798427px, 14.771297px);
    }
    35% {
      transform: translate(148.833827px, -25.703774px);
    }
    36.25% {
      transform: translate(150.920607px, -33.028703px);
    }
    50% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO11_tr {
    animation: e036KGUVLJO11_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO11_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    20% {
      transform: rotate(0deg);
    }
    21.25% {
      transform: rotate(50deg);
    }
    35% {
      transform: rotate(50deg);
    }
    36.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO11 {
    animation: e036KGUVLJO11_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO11_c_o {
    0% {
      opacity: 0;
    }
    7.5% {
      opacity: 0;
    }
    13.75% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    51.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO13 {
    animation-name: e036KGUVLJO13__m, e036KGUVLJO13_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO13__m {
    0% {
      d: path('M32.0957,289.88L32.0957,246.521298L32.0957,246.521298L32.0957,246.524434');
    }
    55% {
      d: path('M32.0957,289.88L32.0957,246.521298L32.0957,246.521298L32.0957,246.524434');
    }
    71.25% {
      d: path('M32.0957,219.88L32.0957,121.861988L32.0957,121.861988L33.0957,120.869117');
    }
    85% {
      d: path('M32.0957,129.146811L32.0957,121.678L85.801035,77.955237L85.801035,77.954434');
    }
    97.5% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
    100% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
  }
  @keyframes e036KGUVLJO13_c_o {
    0% {
      opacity: 0;
    }
    63.75% {
      opacity: 0;
    }
    72.5% {
      opacity: 1;
    }
    95% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO14_to {
    animation: e036KGUVLJO14_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO14_to__to {
    0% {
      transform: translate(96.798427px, 143.537316px);
    }
    55% {
      transform: translate(96.798427px, 143.537316px);
    }
    70% {
      transform: translate(97.111986px, 20.771297px);
    }
    71.25% {
      transform: translate(99.798427px, 14.771297px);
    }
    85% {
      transform: translate(148.801035px, -25.679029px);
    }
    86.25% {
      transform: translate(150.920607px, -33.028703px);
    }
    97.5% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO14_tr {
    animation: e036KGUVLJO14_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO14_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    70% {
      transform: rotate(0deg);
    }
    71.25% {
      transform: rotate(50deg);
    }
    85% {
      transform: rotate(50deg);
    }
    86.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO14 {
    animation: e036KGUVLJO14_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO14_c_o {
    0% {
      opacity: 0;
    }
    57.5% {
      opacity: 0;
    }
    65% {
      opacity: 0.7;
    }
    96.25% {
      opacity: 0.7;
    }
    98.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO15_to {
    animation: e036KGUVLJO15_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO15_to__to {
    0% {
      transform: translate(96.798427px, 142.237316px);
    }
    55% {
      transform: translate(96.798427px, 142.237316px);
    }
    70% {
      transform: translate(97.111986px, 20.643116px);
    }
    71.25% {
      transform: translate(99.798427px, 14.771297px);
    }
    85% {
      transform: translate(148.833827px, -25.703774px);
    }
    86.25% {
      transform: translate(150.920607px, -33.028703px);
    }
    97.5% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO15_tr {
    animation: e036KGUVLJO15_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO15_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    70% {
      transform: rotate(0deg);
    }
    71.25% {
      transform: rotate(50deg);
    }
    85% {
      transform: rotate(50deg);
    }
    86.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO15 {
    animation: e036KGUVLJO15_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO15_c_o {
    0% {
      opacity: 0;
    }
    57.5% {
      opacity: 0;
    }
    65% {
      opacity: 1;
    }
    97.5% {
      opacity: 1;
    }
    98.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO19 {
    animation-name: e036KGUVLJO19__m, e036KGUVLJO19_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO19__m {
    0% {
      d: path(
        'M96.711985,210.915719L96.7109,121.678L96.711985,121.678C96.711985,121.678,97.711985,120.504307,97.711985,120.504307'
      );
    }
    16.25% {
      d: path(
        'M96.7109,121.678L96.7109,121.678L132.580485,77.671631C132.580485,77.671631,133.113203,76.67163,133.113203,76.67163'
      );
    }
    30% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
    100% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
  }
  @keyframes e036KGUVLJO19_c_o {
    0% {
      opacity: 0.2;
    }
    8.75% {
      opacity: 1;
    }
    28.75% {
      opacity: 1;
    }
    33.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO20_to {
    animation: e036KGUVLJO20_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO20_to__to {
    0% {
      transform: translate(160.8px, 20.504306px);
    }
    1.25% {
      transform: translate(164.798427px, 11.502826px);
    }
    16.25% {
      transform: translate(194.801035px, -25.911387px);
    }
    17.5% {
      transform: translate(196.811985px, -34.712684px);
    }
    30% {
      transform: translate(196.811985px, -114.712684px);
    }
    100% {
      transform: translate(196.811985px, -114.712684px);
    }
  }
  #e036KGUVLJO20_tr {
    animation: e036KGUVLJO20_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO20_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    1.25% {
      transform: rotate(39deg);
    }
    16.25% {
      transform: rotate(39deg);
    }
    17.5% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO20 {
    animation: e036KGUVLJO20_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO20_c_o {
    0% {
      opacity: 0.7;
    }
    30% {
      opacity: 0.7;
    }
    31.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO21_to {
    animation: e036KGUVLJO21_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO21_to__to {
    0% {
      transform: translate(160.8px, 20.504307px);
    }
    1.25% {
      transform: translate(164.798427px, 11.502826px);
    }
    16.25% {
      transform: translate(194.801035px, -25.891881px);
    }
    17.5% {
      transform: translate(196.851035px, -34.791881px);
    }
    30% {
      transform: translate(196.851035px, -114.791881px);
    }
    100% {
      transform: translate(196.851035px, -114.791881px);
    }
  }
  #e036KGUVLJO21_tr {
    animation: e036KGUVLJO21_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO21_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    1.25% {
      transform: rotate(39deg);
    }
    16.25% {
      transform: rotate(39deg);
    }
    17.5% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO21 {
    animation: e036KGUVLJO21_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO21_c_o {
    0% {
      opacity: 0;
    }
    1% {
      opacity: 1;
    }
    30% {
      opacity: 1;
    }
    31.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO23 {
    animation-name: e036KGUVLJO23__m, e036KGUVLJO23_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO23__m {
    0% {
      d: path(
        'M96.711985,250.915719L96.7109,216.678L96.711985,216.678C96.711985,216.678,97.711985,215.504307,97.711985,215.504307'
      );
    }
    40% {
      d: path(
        'M96.711985,250.915719L96.7109,216.678L96.711985,216.678C96.711985,216.678,97.711985,215.504307,97.711985,215.504307'
      );
    }
    50% {
      d: path(
        'M96.711985,210.915719L96.7109,121.678L96.711985,121.678C96.711985,121.678,97.711985,120.504307,97.711985,120.504307'
      );
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    66.25% {
      d: path(
        'M96.7109,121.678L96.7109,121.678L132.580485,77.671631C132.580485,77.671631,133.113203,76.67163,133.113203,76.67163'
      );
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    80% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
    100% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
  }
  @keyframes e036KGUVLJO23_c_o {
    0% {
      opacity: 0;
    }
    42.5% {
      opacity: 0;
    }
    52.5% {
      opacity: 1;
    }
    78.75% {
      opacity: 1;
    }
    83.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO24_to {
    animation: e036KGUVLJO24_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO24_to__to {
    0% {
      transform: translate(160.8px, 122.504306px);
    }
    37.5% {
      transform: translate(160.8px, 122.504306px);
    }
    50% {
      transform: translate(160.8px, 20.504306px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    51.25% {
      transform: translate(164.798427px, 11.502826px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    66.25% {
      transform: translate(194.801035px, -25.911387px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    67.5% {
      transform: translate(196.811985px, -34.712684px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    80% {
      transform: translate(196.811985px, -114.712684px);
    }
    100% {
      transform: translate(196.811985px, -114.712684px);
    }
  }
  #e036KGUVLJO24_tr {
    animation: e036KGUVLJO24_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO24_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(0deg);
    }
    51.25% {
      transform: rotate(39deg);
    }
    66.25% {
      transform: rotate(39deg);
    }
    67.5% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO24 {
    animation: e036KGUVLJO24_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO24_c_o {
    0% {
      opacity: 0;
    }
    38.75% {
      opacity: 0;
    }
    50% {
      opacity: 0.7;
    }
    80% {
      opacity: 0.7;
    }
    81.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO25_to {
    animation: e036KGUVLJO25_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO25_to__to {
    0% {
      transform: translate(160.8px, 122.504307px);
    }
    37.5% {
      transform: translate(160.8px, 122.504307px);
    }
    50% {
      transform: translate(160.8px, 20.504307px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    51.25% {
      transform: translate(164.798427px, 11.502826px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    66.25% {
      transform: translate(194.801035px, -25.891881px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    67.5% {
      transform: translate(196.851035px, -34.791881px);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    80% {
      transform: translate(196.851035px, -114.791881px);
    }
    100% {
      transform: translate(196.851035px, -114.791881px);
    }
  }
  #e036KGUVLJO25_tr {
    animation: e036KGUVLJO25_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO25_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(0deg);
    }
    51.25% {
      transform: rotate(39deg);
    }
    66.25% {
      transform: rotate(39deg);
    }
    67.5% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO25 {
    animation: e036KGUVLJO25_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO25_c_o {
    0% {
      opacity: 0;
    }
    38.75% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    80% {
      opacity: 1;
    }
    81.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO27 {
    animation-name: e036KGUVLJO27__m, e036KGUVLJO27_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO27__m {
    0% {
      d: path(
        'M96.711985,250.915719L96.7109,216.678L96.711985,216.678C96.711985,216.678,97.711985,215.504307,97.711985,215.504307'
      );
    }
    90% {
      d: path(
        'M96.711985,250.915719L96.7109,216.678L96.711985,216.678C96.711985,216.678,97.711985,215.504307,97.711985,215.504307'
      );
    }
    100% {
      d: path(
        'M96.711985,210.915719L96.7109,121.678L96.711985,121.678C96.711985,121.678,97.711985,120.504307,97.711985,120.504307'
      );
    }
  }
  @keyframes e036KGUVLJO27_c_o {
    0% {
      opacity: 0;
    }
    92.5% {
      opacity: 0;
    }
    100% {
      opacity: 0.2;
    }
  }
  #e036KGUVLJO28_to {
    animation: e036KGUVLJO28_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO28_to__to {
    0% {
      transform: translate(160.8px, 122.504306px);
    }
    87.5% {
      transform: translate(160.8px, 122.504306px);
    }
    100% {
      transform: translate(160.8px, 20.504306px);
    }
  }
  #e036KGUVLJO28 {
    animation: e036KGUVLJO28_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO28_c_o {
    0% {
      opacity: 0;
    }
    88.75% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }
  #e036KGUVLJO29_to {
    animation: e036KGUVLJO29_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO29_to__to {
    0% {
      transform: translate(160.8px, 122.504307px);
    }
    87.5% {
      transform: translate(160.8px, 122.504307px);
    }
    100% {
      transform: translate(160.8px, 20.504307px);
    }
  }
  #e036KGUVLJO29 {
    animation: e036KGUVLJO29_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO29_c_o {
    0% {
      opacity: 0;
    }
    88.75% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #e036KGUVLJO33 {
    animation-name: e036KGUVLJO33__m, e036KGUVLJO33_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO33__m {
    0% {
      d: path(
        'M161.867,259.879L161.867,210.489998C161.867,210.489998,161.85,210.271299,161.85,210.271299L162.798427,208.396294'
      );
    }
    13.75% {
      d: path(
        'M161.867,259.879L161.867,210.489998C161.867,210.489998,161.85,210.271299,161.85,210.271299L162.798427,208.396294'
      );
    }
    26.25% {
      d: path(
        'M161.867,217.545667L161.870499,121.695859C161.870499,121.695859,161.870499,121.695861,161.870499,121.695861L162.870499,120.695859'
      );
    }
    38.75% {
      d: path(
        'M161.867318,121.678L161.867318,121.678714C161.867318,121.678714,180.683499,77.67163,180.683499,77.67163L181.683499,75.67163'
      );
    }
    52.5% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,77.67163,180.683499,77.67163L180.683499,-3.712681'
      );
    }
    100% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,77.67163,180.683499,77.67163L180.683499,-3.712681'
      );
    }
  }
  @keyframes e036KGUVLJO33_c_o {
    0% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    27.5% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    56.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO34_to {
    animation: e036KGUVLJO34_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO34_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    11.25% {
      transform: translate(226.779751px, 128.661481px);
    }
    26.25% {
      transform: translate(226.798427px, 20.521297px);
    }
    27.5% {
      transform: translate(229.798427px, 10.771297px);
    }
    38.75% {
      transform: translate(244.801035px, -24.5px);
    }
    40% {
      transform: translate(245.711986px, -32.410292px);
    }
    53.75% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO34_tr {
    animation: e036KGUVLJO34_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO34_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    26.25% {
      transform: rotate(0deg);
    }
    27.5% {
      transform: rotate(23deg);
    }
    38.75% {
      transform: rotate(23deg);
    }
    40% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO34 {
    animation: e036KGUVLJO34_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO34_c_o {
    0% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    21.25% {
      opacity: 0.7;
    }
    53.75% {
      opacity: 0.7;
    }
    55% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO35_to {
    animation: e036KGUVLJO35_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO35_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    11.25% {
      transform: translate(226.779751px, 128.661481px);
    }
    26.25% {
      transform: translate(226.798427px, 20.521297px);
    }
    27.5% {
      transform: translate(229.798427px, 10.771297px);
    }
    38.75% {
      transform: translate(244.801035px, -24.5px);
    }
    40% {
      transform: translate(245.711986px, -32.410292px);
    }
    53.75% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO35_tr {
    animation: e036KGUVLJO35_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO35_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    26.25% {
      transform: rotate(0deg);
    }
    27.5% {
      transform: rotate(23deg);
    }
    38.75% {
      transform: rotate(23deg);
    }
    40% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO35 {
    animation: e036KGUVLJO35_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO35_c_o {
    0% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    21.25% {
      opacity: 1;
    }
    53.75% {
      opacity: 1;
    }
    55% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO37 {
    animation-name: e036KGUVLJO37__m, e036KGUVLJO37_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO37__m {
    0% {
      d: path(
        'M161.867,259.879L161.867,210.489998C161.867,210.489998,161.85,210.271299,161.85,210.271299L162.798427,208.396294'
      );
    }
    55% {
      d: path(
        'M161.867,259.879L161.867,210.489998C161.867,210.489998,161.85,210.271299,161.85,210.271299L162.798427,208.396294'
      );
    }
    67.5% {
      d: path(
        'M161.867,217.545667L161.870499,121.695859C161.870499,121.695859,161.870499,121.695861,161.870499,121.695861L162.870499,120.695859'
      );
    }
    80% {
      d: path(
        'M161.867318,121.678L161.867318,121.678714C161.867318,121.678714,180.683499,77.67163,180.683499,77.67163L181.683499,75.67163'
      );
    }
    93.75% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,77.67163,180.683499,77.67163L180.683499,-3.712681'
      );
    }
    100% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,77.67163,180.683499,77.67163L180.683499,-3.712681'
      );
    }
  }
  @keyframes e036KGUVLJO37_c_o {
    0% {
      opacity: 0;
    }
    55% {
      opacity: 0;
    }
    68.75% {
      opacity: 1;
    }
    91.25% {
      opacity: 1;
    }
    97.5% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO38_to {
    animation: e036KGUVLJO38_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO38_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    52.5% {
      transform: translate(226.779751px, 128.661481px);
    }
    67.5% {
      transform: translate(226.798427px, 20.521297px);
    }
    68.75% {
      transform: translate(229.798427px, 10.771297px);
    }
    80% {
      transform: translate(244.801035px, -24.5px);
    }
    81.25% {
      transform: translate(245.711986px, -32.410292px);
    }
    95% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO38_tr {
    animation: e036KGUVLJO38_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO38_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    67.5% {
      transform: rotate(0deg);
    }
    68.75% {
      transform: rotate(23deg);
    }
    80% {
      transform: rotate(23deg);
    }
    81.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO38 {
    animation: e036KGUVLJO38_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO38_c_o {
    0% {
      opacity: 0;
    }
    55% {
      opacity: 0;
    }
    62.5% {
      opacity: 0.7;
    }
    95% {
      opacity: 0.7;
    }
    96.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO39_to {
    animation: e036KGUVLJO39_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO39_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    52.5% {
      transform: translate(226.779751px, 128.661481px);
    }
    67.5% {
      transform: translate(226.798427px, 20.521297px);
    }
    68.75% {
      transform: translate(229.798427px, 10.771297px);
    }
    80% {
      transform: translate(244.801035px, -24.5px);
    }
    81.25% {
      transform: translate(245.711986px, -32.410292px);
    }
    95% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO39_tr {
    animation: e036KGUVLJO39_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO39_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    67.5% {
      transform: rotate(0deg);
    }
    68.75% {
      transform: rotate(23deg);
    }
    80% {
      transform: rotate(23deg);
    }
    81.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO39 {
    animation: e036KGUVLJO39_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO39_c_o {
    0% {
      opacity: 0;
    }
    55% {
      opacity: 0;
    }
    62.5% {
      opacity: 1;
    }
    95% {
      opacity: 1;
    }
    96.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO43 {
    animation-name: e036KGUVLJO43__m, e036KGUVLJO43_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO43__m {
    0% {
      d: path(
        'M161.867,259.879L161.867,253.489998C161.867,253.489998,161.85,251.271299,161.85,251.271299L161.798427,249.396294'
      );
    }
    11.25% {
      d: path(
        'M161.867,236.545667L161.870499,121.695859C161.870499,121.695859,161.870499,121.695861,161.870499,121.695861L162.870499,120.695859'
      );
    }
    22.5% {
      d: path(
        'M161.867312,123.943486L161.867381,121.679052C161.867381,121.679052,180.312458,78.539901,180.312458,78.539901L181.312458,77.539901'
      );
    }
    23.75% {
      d: path(
        'M161.867318,121.678L180.685485,77.671631C180.685485,77.671631,180.683499,77.67163,180.683499,77.67163L181.683499,76.67163'
      );
    }
    37.5% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,-3.32837,180.683499,-3.32837L181.683499,-4.712681'
      );
    }
    100% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,-3.32837,180.683499,-3.32837L181.683499,-4.712681'
      );
    }
  }
  @keyframes e036KGUVLJO43_c_o {
    0% {
      opacity: 0;
    }
    7.5% {
      opacity: 0;
    }
    15% {
      opacity: 1;
    }
    35% {
      opacity: 1;
    }
    40% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO44_to {
    animation: e036KGUVLJO44_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO44_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    1.25% {
      transform: translate(226.779751px, 128.661481px);
    }
    11.25% {
      transform: translate(226.798427px, 20.521297px);
    }
    12.5% {
      transform: translate(229.798427px, 10.771297px);
    }
    23.75% {
      transform: translate(244.801035px, -25.5px);
    }
    25% {
      transform: translate(245.711986px, -32.410292px);
    }
    37.5% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO44_tr {
    animation: e036KGUVLJO44_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO44_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    11.25% {
      transform: rotate(0deg);
    }
    12.5% {
      transform: rotate(23deg);
    }
    23.75% {
      transform: rotate(23deg);
    }
    25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO44 {
    animation: e036KGUVLJO44_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO44_c_o {
    0% {
      opacity: 0;
    }
    3.75% {
      opacity: 0;
    }
    10% {
      opacity: 0.7;
    }
    37.5% {
      opacity: 0.7;
    }
    38.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO45_to {
    animation: e036KGUVLJO45_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO45_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    1.25% {
      transform: translate(226.779751px, 128.661481px);
    }
    11.25% {
      transform: translate(226.798427px, 20.521297px);
    }
    12.5% {
      transform: translate(229.798427px, 10.771297px);
    }
    23.75% {
      transform: translate(244.801035px, -25.5px);
    }
    25% {
      transform: translate(245.711986px, -32.410292px);
    }
    37.5% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO45_tr {
    animation: e036KGUVLJO45_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO45_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    11.25% {
      transform: rotate(0deg);
    }
    12.5% {
      transform: rotate(23deg);
    }
    23.75% {
      transform: rotate(23deg);
    }
    25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO45 {
    animation: e036KGUVLJO45_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO45_c_o {
    0% {
      opacity: 0;
    }
    3.75% {
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    37.5% {
      opacity: 1;
    }
    38.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO47 {
    animation-name: e036KGUVLJO47__m, e036KGUVLJO47_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO47__m {
    0% {
      d: path(
        'M161.867,259.879L161.867,253.489998C161.867,253.489998,161.85,251.271299,161.85,251.271299L161.798427,249.396294'
      );
    }
    46.25% {
      d: path(
        'M161.867,259.879L161.867,253.489998C161.867,253.489998,161.85,251.271299,161.85,251.271299L161.798427,249.396294'
      );
    }
    57.5% {
      d: path(
        'M161.867,236.545667L161.870499,121.695859C161.870499,121.695859,161.870499,121.695861,161.870499,121.695861L162.870499,120.695859'
      );
    }
    68.75% {
      d: path(
        'M161.867312,123.943486L161.867381,121.679052C161.867381,121.679052,180.312458,78.539901,180.312458,78.539901L181.312458,77.539901'
      );
    }
    70% {
      d: path(
        'M161.867318,121.678L180.685485,77.671631C180.685485,77.671631,180.683499,77.67163,180.683499,77.67163L181.683499,76.67163'
      );
    }
    83.75% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,-3.32837,180.683499,-3.32837L181.683499,-4.712681'
      );
    }
    100% {
      d: path(
        'M180.683499,77.670918L180.683499,77.671631C180.683499,77.671631,180.683499,-3.32837,180.683499,-3.32837L181.683499,-4.712681'
      );
    }
  }
  @keyframes e036KGUVLJO47_c_o {
    0% {
      opacity: 0;
    }
    53.75% {
      opacity: 0;
    }
    61.25% {
      opacity: 1;
    }
    81.25% {
      opacity: 1;
    }
    86.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO48_to {
    animation: e036KGUVLJO48_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO48_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    47.5% {
      transform: translate(226.779751px, 128.661481px);
    }
    57.5% {
      transform: translate(226.798427px, 20.521297px);
    }
    58.75% {
      transform: translate(229.798427px, 10.771297px);
    }
    70% {
      transform: translate(244.801035px, -25.5px);
    }
    71.25% {
      transform: translate(245.711986px, -32.410292px);
    }
    83.75% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO48_tr {
    animation: e036KGUVLJO48_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO48_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    57.5% {
      transform: rotate(0deg);
    }
    58.75% {
      transform: rotate(23deg);
    }
    70% {
      transform: rotate(23deg);
    }
    71.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO48 {
    animation: e036KGUVLJO48_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO48_c_o {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    56.25% {
      opacity: 0.7;
    }
    83.75% {
      opacity: 0.7;
    }
    85% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO49_to {
    animation: e036KGUVLJO49_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO49_to__to {
    0% {
      transform: translate(226.779751px, 128.661481px);
    }
    47.5% {
      transform: translate(226.779751px, 128.661481px);
    }
    57.5% {
      transform: translate(226.798427px, 20.521297px);
    }
    58.75% {
      transform: translate(229.798427px, 10.771297px);
    }
    70% {
      transform: translate(244.801035px, -25.5px);
    }
    71.25% {
      transform: translate(245.711986px, -32.410292px);
    }
    83.75% {
      transform: translate(245.711986px, -119.410292px);
    }
    100% {
      transform: translate(245.711986px, -119.410292px);
    }
  }
  #e036KGUVLJO49_tr {
    animation: e036KGUVLJO49_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO49_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    57.5% {
      transform: rotate(0deg);
    }
    58.75% {
      transform: rotate(23deg);
    }
    70% {
      transform: rotate(23deg);
    }
    71.25% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO49 {
    animation: e036KGUVLJO49_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO49_c_o {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    56.25% {
      opacity: 1;
    }
    83.75% {
      opacity: 1;
    }
    85% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO53 {
    animation-name: e036KGUVLJO53__m, e036KGUVLJO53_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO53__m {
    0% {
      d: path(
        'M96.711985,302.439636L96.7109,234.987317L96.711985,234.987317C96.711985,234.987317,96.711985,234.987317,96.711985,234.987317'
      );
    }
    3.75% {
      d: path(
        'M96.711985,302.439636L96.7109,234.987317L96.711985,234.987317C96.711985,234.987317,96.711985,234.987317,96.711985,234.987317'
      );
    }
    17.5% {
      d: path(
        'M96.711985,195.439636L96.7109,127.987317L96.711985,127.987317C96.711985,127.987317,96.711985,127.987317,96.711985,127.987317'
      );
    }
    18.75% {
      d: path(
        'M96.7109,175.771298L96.7109,121.68L96.798427,121.683001C96.798427,121.683001,96.711985,121.683001,96.711985,121.683001'
      );
    }
    33.75% {
      d: path(
        'M96.7109,121.678L96.7109,121.678L132.580485,77.671631C132.580485,77.671631,132.580485,77.67163,132.580485,77.67163'
      );
    }
    47.5% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
    100% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
  }
  @keyframes e036KGUVLJO53_c_o {
    0% {
      opacity: 0;
    }
    3.75% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    21.25% {
      opacity: 1;
    }
    45% {
      opacity: 1;
    }
    51.25% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO54_to {
    animation: e036KGUVLJO54_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO54_to__to {
    0% {
      transform: translate(160.8px, 124.504306px);
    }
    5% {
      transform: translate(160.8px, 124.504306px);
    }
    17.5% {
      transform: translate(160.8px, 24.504306px);
    }
    18.75% {
      transform: translate(164.798427px, 11.502826px);
    }
    33.75% {
      transform: translate(193.801035px, -23.911387px);
    }
    35% {
      transform: translate(196.811985px, -34.712684px);
    }
    47.5% {
      transform: translate(196.811985px, -114.712684px);
    }
    100% {
      transform: translate(196.811985px, -114.712684px);
    }
  }
  #e036KGUVLJO54_tr {
    animation: e036KGUVLJO54_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO54_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    17.5% {
      transform: rotate(0deg);
    }
    18.75% {
      transform: rotate(39deg);
    }
    33.75% {
      transform: rotate(39deg);
    }
    35% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO54 {
    animation: e036KGUVLJO54_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO54_c_o {
    0% {
      opacity: 0;
    }
    7.5% {
      opacity: 0;
    }
    12.5% {
      opacity: 0.7;
    }
    17.5% {
      opacity: 0.7;
    }
    47.5% {
      opacity: 0.7;
    }
    48.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO55_to {
    animation: e036KGUVLJO55_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO55_to__to {
    0% {
      transform: translate(160.8px, 124.504307px);
    }
    5% {
      transform: translate(160.8px, 124.504307px);
    }
    17.5% {
      transform: translate(160.8px, 24.504307px);
    }
    18.75% {
      transform: translate(164.798427px, 11.502826px);
    }
    33.75% {
      transform: translate(193.801035px, -23.891881px);
    }
    35% {
      transform: translate(196.851035px, -34.791881px);
    }
    47.5% {
      transform: translate(196.851035px, -114.791881px);
    }
    100% {
      transform: translate(196.851035px, -114.791881px);
    }
  }
  #e036KGUVLJO55_tr {
    animation: e036KGUVLJO55_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO55_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    17.5% {
      transform: rotate(0deg);
    }
    18.75% {
      transform: rotate(39deg);
    }
    33.75% {
      transform: rotate(39deg);
    }
    35% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO55 {
    animation: e036KGUVLJO55_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO55_c_o {
    0% {
      opacity: 0;
    }
    7.5% {
      opacity: 0;
    }
    12.5% {
      opacity: 1;
    }
    17.5% {
      opacity: 1;
    }
    47.5% {
      opacity: 1;
    }
    48.75% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO57 {
    animation-name: e036KGUVLJO57__m, e036KGUVLJO57_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO57__m {
    0% {
      d: path(
        'M96.711985,302.439636L96.7109,234.987317L96.711985,234.987317C96.711985,234.987317,96.711985,234.987317,96.711985,234.987317'
      );
    }
    52.5% {
      d: path(
        'M96.711985,302.439636L96.7109,234.987317L96.711985,234.987317C96.711985,234.987317,96.711985,234.987317,96.711985,234.987317'
      );
    }
    66.25% {
      d: path(
        'M96.711985,195.439636L96.7109,127.987317L96.711985,127.987317C96.711985,127.987317,96.711985,127.987317,96.711985,127.987317'
      );
    }
    67.5% {
      d: path(
        'M96.7109,175.771298L96.7109,121.68L96.798427,121.683001C96.798427,121.683001,96.711985,121.683001,96.711985,121.683001'
      );
    }
    82.5% {
      d: path(
        'M96.7109,121.678L96.7109,121.678L132.580485,77.671631C132.580485,77.671631,132.580485,77.67163,132.580485,77.67163'
      );
    }
    96.25% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
    100% {
      d: path(
        'M132.580485,77.671631L132.580485,77.671631L132.580485,77.671631C132.580485,77.671631,132.580485,-3.79188,132.580485,-3.79188'
      );
    }
  }
  @keyframes e036KGUVLJO57_c_o {
    0% {
      opacity: 0;
    }
    52.5% {
      opacity: 0;
    }
    57.5% {
      opacity: 0;
    }
    62.5% {
      opacity: 0.3;
    }
    67.5% {
      opacity: 1;
    }
    95% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO58_to {
    animation: e036KGUVLJO58_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO58_to__to {
    0% {
      transform: translate(160.8px, 124.504306px);
    }
    53.75% {
      transform: translate(160.8px, 124.504306px);
    }
    66.25% {
      transform: translate(160.8px, 24.504306px);
    }
    67.5% {
      transform: translate(164.798427px, 11.502826px);
    }
    82.5% {
      transform: translate(193.801035px, -23.911387px);
    }
    83.75% {
      transform: translate(196.811985px, -34.712684px);
    }
    96.25% {
      transform: translate(196.811985px, -114.712684px);
    }
    100% {
      transform: translate(196.811985px, -114.712684px);
    }
  }
  #e036KGUVLJO58_tr {
    animation: e036KGUVLJO58_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO58_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    66.25% {
      transform: rotate(0deg);
    }
    67.5% {
      transform: rotate(39deg);
    }
    82.5% {
      transform: rotate(39deg);
    }
    83.75% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO58 {
    animation: e036KGUVLJO58_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO58_c_o {
    0% {
      opacity: 0;
    }
    56.25% {
      opacity: 0;
    }
    61.25% {
      opacity: 0.7;
    }
    66.25% {
      opacity: 0.7;
    }
    96.25% {
      opacity: 0.7;
    }
    97.5% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO59_to {
    animation: e036KGUVLJO59_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO59_to__to {
    0% {
      transform: translate(160.8px, 124.504307px);
    }
    53.75% {
      transform: translate(160.8px, 124.504307px);
    }
    66.25% {
      transform: translate(160.8px, 24.504307px);
    }
    67.5% {
      transform: translate(164.798427px, 11.502826px);
    }
    82.5% {
      transform: translate(193.801035px, -23.891881px);
    }
    83.75% {
      transform: translate(196.851035px, -34.791881px);
    }
    96.25% {
      transform: translate(196.851035px, -114.791881px);
    }
    100% {
      transform: translate(196.851035px, -114.791881px);
    }
  }
  #e036KGUVLJO59_tr {
    animation: e036KGUVLJO59_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO59_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    66.25% {
      transform: rotate(0deg);
    }
    67.5% {
      transform: rotate(39deg);
    }
    82.5% {
      transform: rotate(39deg);
    }
    83.75% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO59 {
    animation: e036KGUVLJO59_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO59_c_o {
    0% {
      opacity: 0;
    }
    56.25% {
      opacity: 0;
    }
    61.25% {
      opacity: 1;
    }
    66.25% {
      opacity: 1;
    }
    96.25% {
      opacity: 1;
    }
    97.5% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO63 {
    animation-name: e036KGUVLJO63__m, e036KGUVLJO63_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO63__m {
    0% {
      d: path('M32.0957,321.564875L32.0957,231.828536L32.101049,231.870431L32.101049,231.876118');
    }
    12.5% {
      d: path('M32.0957,321.564875L32.0957,231.828536L32.101049,231.870431L32.101049,231.876118');
    }
    26.25% {
      d: path('M32.0957,211.564875L32.0957,121.828536L32.101049,121.870431L32.101049,121.876118');
    }
    41.25% {
      d: path('M32.0957,129.146811L32.0957,121.678L85.801035,77.955237L85.801035,77.954434');
    }
    56.25% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
    100% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
  }
  @keyframes e036KGUVLJO63_c_o {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 0;
    }
    22.5% {
      opacity: 0;
    }
    30% {
      opacity: 1;
    }
    52.5% {
      opacity: 1;
    }
    57.5% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO64_to {
    animation: e036KGUVLJO64_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO64_to__to {
    0% {
      transform: translate(96.798427px, 143.537316px);
    }
    11.25% {
      transform: translate(96.798427px, 143.537316px);
    }
    26.25% {
      transform: translate(97.111986px, 20.771297px);
    }
    27.5% {
      transform: translate(99.798427px, 14.771297px);
    }
    41.25% {
      transform: translate(148.801035px, -25.679029px);
    }
    42.5% {
      transform: translate(150.920607px, -33.028703px);
    }
    56.25% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO64_tr {
    animation: e036KGUVLJO64_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO64_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    26.25% {
      transform: rotate(0deg);
    }
    27.5% {
      transform: rotate(50deg);
    }
    41.25% {
      transform: rotate(50deg);
    }
    42.5% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO64 {
    animation: e036KGUVLJO64_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO64_c_o {
    0% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    20% {
      opacity: 0.7;
    }
    56.25% {
      opacity: 0.7;
    }
    57.5% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO65_to {
    animation: e036KGUVLJO65_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO65_to__to {
    0% {
      transform: translate(96.798427px, 142.237316px);
    }
    11.25% {
      transform: translate(96.798427px, 142.237316px);
    }
    26.25% {
      transform: translate(97.111986px, 20.643116px);
    }
    27.5% {
      transform: translate(99.798427px, 14.771297px);
    }
    41.25% {
      transform: translate(148.833827px, -25.703774px);
    }
    42.5% {
      transform: translate(150.920607px, -33.028703px);
    }
    56.25% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO65_tr {
    animation: e036KGUVLJO65_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO65_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    26.25% {
      transform: rotate(0deg);
    }
    27.5% {
      transform: rotate(50deg);
    }
    41.25% {
      transform: rotate(50deg);
    }
    42.5% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO65 {
    animation: e036KGUVLJO65_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO65_c_o {
    0% {
      opacity: 0;
    }
    13.75% {
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    56.25% {
      opacity: 1;
    }
    57.5% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO67 {
    animation-name: e036KGUVLJO67__m, e036KGUVLJO67_c_o;
    animation-duration: 8000ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes e036KGUVLJO67__m {
    0% {
      d: path('M32.0957,321.564875L32.0957,231.828536L32.101049,231.870431L32.101049,231.876118');
    }
    55% {
      d: path('M32.0957,321.564875L32.0957,231.828536L32.101049,231.870431L32.101049,231.876118');
    }
    68.75% {
      d: path('M32.0957,211.564875L32.0957,121.828536L32.101049,121.870431L32.101049,121.876118');
    }
    83.75% {
      d: path('M32.0957,129.146811L32.0957,121.678L85.801035,77.955237L85.801035,77.954434');
    }
    98.75% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
    100% {
      d: path('M86.161435,77.676826L86.161435,77.676826L86.1598,77.676826L86.1598,-5.543385');
    }
  }
  @keyframes e036KGUVLJO67_c_o {
    0% {
      opacity: 0;
    }
    52.5% {
      opacity: 0;
    }
    65% {
      opacity: 0;
    }
    72.5% {
      opacity: 1;
    }
    95% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO68_to {
    animation: e036KGUVLJO68_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO68_to__to {
    0% {
      transform: translate(96.798427px, 143.537316px);
    }
    53.75% {
      transform: translate(96.798427px, 143.537316px);
    }
    68.75% {
      transform: translate(97.111986px, 20.771297px);
    }
    70% {
      transform: translate(99.798427px, 14.771297px);
    }
    83.75% {
      transform: translate(148.801035px, -25.679029px);
    }
    85% {
      transform: translate(150.920607px, -33.028703px);
    }
    98.75% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO68_tr {
    animation: e036KGUVLJO68_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO68_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    68.75% {
      transform: rotate(0deg);
    }
    70% {
      transform: rotate(50deg);
    }
    83.75% {
      transform: rotate(50deg);
    }
    85% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO68 {
    animation: e036KGUVLJO68_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO68_c_o {
    0% {
      opacity: 0;
    }
    56.25% {
      opacity: 0;
    }
    62.5% {
      opacity: 0.7;
    }
    98.75% {
      opacity: 0.7;
    }
    100% {
      opacity: 0;
    }
  }
  #e036KGUVLJO69_to {
    animation: e036KGUVLJO69_to__to 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO69_to__to {
    0% {
      transform: translate(96.798427px, 142.237316px);
    }
    53.75% {
      transform: translate(96.798427px, 142.237316px);
    }
    68.75% {
      transform: translate(97.111986px, 20.643116px);
    }
    70% {
      transform: translate(99.798427px, 14.771297px);
    }
    83.75% {
      transform: translate(148.833827px, -25.703774px);
    }
    85% {
      transform: translate(150.920607px, -33.028703px);
    }
    98.75% {
      transform: translate(150.920607px, -113.028703px);
    }
    100% {
      transform: translate(150.920607px, -113.028703px);
    }
  }
  #e036KGUVLJO69_tr {
    animation: e036KGUVLJO69_tr__tr 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO69_tr__tr {
    0% {
      transform: rotate(0deg);
    }
    68.75% {
      transform: rotate(0deg);
    }
    70% {
      transform: rotate(50deg);
    }
    83.75% {
      transform: rotate(50deg);
    }
    85% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  #e036KGUVLJO69 {
    animation: e036KGUVLJO69_c_o 8000ms linear infinite normal forwards;
  }
  @keyframes e036KGUVLJO69_c_o {
    0% {
      opacity: 0;
    }
    56.25% {
      opacity: 0;
    }
    62.5% {
      opacity: 1;
    }
    98.75% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export default FeedSourcesMobileBg6;
